import script from "./BListGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./BListGroup.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__